module.exports = __webpack_public_path__ + "static/media/electric_on.30bed1ba.svg";